/*************************************************************************************/
/*************** NUMBER CAKE – ONE SIZE, ONE NUMBER, ONE CART PROPERTY ****************/
/*************************************************************************************/

(function () {
  const PRODUCT_HANDLE = 'number-cake';

  const SINGLE_FIELD_SELECTOR =
    '.gpo-element.single_digit';

  const DOUBLE_FIELD_SELECTOR =
    '.gpo-element.double_digit';

  const SINGLE_PROPERTY =
    'Single Digit Cake Number';

  const DOUBLE_PROPERTY =
    'Double Digit Cake Number';

  const ERROR_CLASS =
    'number-cake-number-error';

  let previousSize = '';
  let updateTimer = null;

  /***********************************************************************************/
  /* RUN ONLY ON NUMBER CAKE                                                         */
  /***********************************************************************************/

  function isNumberCakePage() {
    return window.location.pathname.includes(
      '/products/' + PRODUCT_HANDLE
    );
  }

  /***********************************************************************************/
  /* GET FIELDS                                                                      */
  /***********************************************************************************/

  function getSingleField() {
    return document.querySelector(
      SINGLE_FIELD_SELECTOR
    );
  }

  function getDoubleField() {
    return document.querySelector(
      DOUBLE_FIELD_SELECTOR
    );
  }

  /***********************************************************************************/
  /* GET SELECTED SIZE                                                               */
  /***********************************************************************************/

  function getSelectedSize() {
    const checkedRadios = document.querySelectorAll(
      'input[type="radio"]:checked'
    );

    for (const radio of checkedRadios) {
      /*
       * Ignore Globo number radios.
       */
      if (
        radio.closest(SINGLE_FIELD_SELECTOR) ||
        radio.closest(DOUBLE_FIELD_SELECTOR)
      ) {
        continue;
      }

      const value = String(
        radio.value || ''
      )
        .trim()
        .toLowerCase();

      if (value === 'single digit') {
        return 'single';
      }

      if (value === 'double digit') {
        return 'double';
      }

      if (radio.id) {
        const label = document.querySelector(
          'label[for="' +
            CSS.escape(radio.id) +
          '"]'
        );

        const text = String(
          label?.textContent || ''
        )
          .trim()
          .toLowerCase();

        if (text.includes('single digit')) {
          return 'single';
        }

        if (text.includes('double digit')) {
          return 'double';
        }
      }
    }

    return '';
  }

  /***********************************************************************************/
  /* GET NUMBER RADIOS                                                               */
  /***********************************************************************************/

  function getNumberRadios(field) {
    if (!field) return [];

    return Array.from(
      field.querySelectorAll(
        'input[type="radio"][data-type="dropdown"]'
      )
    );
  }

  function getSelectedNumber(field) {
    if (!field) return null;

    return field.querySelector(
      'input[type="radio"][data-type="dropdown"]:checked'
    );
  }

  /***********************************************************************************/
  /* GET GLOBO HIDDEN PROPERTY INPUT                                                  */
  /***********************************************************************************/

  function getHiddenPropertyInput(propertyName) {
    return document.querySelector(
      '.gpo-hidden-inputs ' +
      'input[type="hidden"][data-field-name="' +
      CSS.escape(propertyName) +
      '"]'
    );
  }

  /***********************************************************************************/
  /* CLEAR GLOBO HIDDEN PROPERTY                                                      */
  /***********************************************************************************/

  function clearHiddenProperty(propertyName) {
    const hiddenInput =
      getHiddenPropertyInput(propertyName);

    if (!hiddenInput) return;

    hiddenInput.value = '';
    hiddenInput.removeAttribute('value');
    hiddenInput.removeAttribute('data-value');
    hiddenInput.disabled = true;

    /*
     * Remove Shopify property name so the empty or old
     * value cannot be submitted.
     */
    hiddenInput.removeAttribute('name');
  }

  /***********************************************************************************/
  /* ACTIVATE GLOBO HIDDEN PROPERTY                                                   */
  /***********************************************************************************/

  function activateHiddenProperty(
    propertyName,
    value
  ) {
    const hiddenInput =
      getHiddenPropertyInput(propertyName);

    if (!hiddenInput) return;

    hiddenInput.disabled = false;

    hiddenInput.setAttribute(
      'name',
      'properties[' + propertyName + ']'
    );

    hiddenInput.value = value || '';

    if (value) {
      hiddenInput.setAttribute(
        'value',
        value
      );

      hiddenInput.setAttribute(
        'data-value',
        value
      );
    } else {
      hiddenInput.removeAttribute('value');
      hiddenInput.removeAttribute('data-value');
    }
  }

  /***********************************************************************************/
  /* RESET VISIBLE GLOBO NUMBER FIELD                                                 */
  /***********************************************************************************/

  function clearNumberField(
    field,
    placeholder
  ) {
    if (!field) return;

    getNumberRadios(field).forEach(function (radio) {
      radio.checked = false;
      radio.removeAttribute('checked');

      radio.setAttribute(
        'previous-value',
        'false'
      );
    });

    field
      .querySelectorAll('.dropdown-item')
      .forEach(function (item) {
        item.classList.remove(
          'selected',
          'active',
          'gpo-selected'
        );
      });

    const dropdownValue = field.querySelector(
      '.dropdown-button__value'
    );

    if (dropdownValue) {
      dropdownValue.textContent = placeholder;
    }

    const selectedValues = field.querySelector(
      '.gpo-selected-values'
    );

    if (selectedValues) {
      selectedValues.textContent = '';
    }

    const messages = field.querySelector(
      '.messages'
    );

    if (messages) {
      messages.innerHTML = '';
    }
  }

  /***********************************************************************************/
  /* SHOW FIELD                                                                      */
  /***********************************************************************************/

  function showField(field) {
    if (!field) return;

    field.style.setProperty(
      'display',
      'block',
      'important'
    );

    field.removeAttribute('aria-hidden');

    getNumberRadios(field).forEach(function (radio) {
      radio.disabled = false;
      radio.required = false;
      radio.removeAttribute('required');
    });
  }

  /***********************************************************************************/
  /* HIDE FIELD                                                                      */
  /***********************************************************************************/

  function hideField(field) {
    if (!field) return;

    field.style.setProperty(
      'display',
      'none',
      'important'
    );

    field.setAttribute(
      'aria-hidden',
      'true'
    );

    getNumberRadios(field).forEach(function (radio) {
      radio.disabled = true;
      radio.required = false;
      radio.removeAttribute('required');
    });
  }

  /***********************************************************************************/
  /* CLEAR SINGLE DIGIT                                                              */
  /***********************************************************************************/

  function clearSingleDigit() {
    clearNumberField(
      getSingleField(),
      'Select Single Digit'
    );

    clearHiddenProperty(
      SINGLE_PROPERTY
    );
  }

  /***********************************************************************************/
  /* CLEAR DOUBLE DIGIT                                                              */
  /***********************************************************************************/

  function clearDoubleDigit() {
    clearNumberField(
      getDoubleField(),
      'Select Double Digit'
    );

    clearHiddenProperty(
      DOUBLE_PROPERTY
    );
  }

  /***********************************************************************************/
  /* REMOVE ERROR                                                                    */
  /***********************************************************************************/

  function removeError() {
    document
      .querySelectorAll(
        '.' + ERROR_CLASS
      )
      .forEach(function (error) {
        error.remove();
      });
  }

  function showError(field, message) {
    removeError();

    if (!field) return;

    const error =
      document.createElement('div');

    error.className = ERROR_CLASS;
    error.textContent = message;

    error.style.color = '#e84c5b';
    error.style.fontSize = '14px';
    error.style.marginTop = '5px';

    field.insertAdjacentElement(
      'afterend',
      error
    );
  }

  /***********************************************************************************/
  /* SYNC ACTIVE PROPERTY                                                            */
  /***********************************************************************************/

  function syncActiveProperty() {
    const size = getSelectedSize();

    const singleField =
      getSingleField();

    const doubleField =
      getDoubleField();

    if (size === 'single') {
      const selected =
        getSelectedNumber(singleField);

      activateHiddenProperty(
        SINGLE_PROPERTY,
        selected ? selected.value : ''
      );

      clearHiddenProperty(
        DOUBLE_PROPERTY
      );
    }

    if (size === 'double') {
      const selected =
        getSelectedNumber(doubleField);

      activateHiddenProperty(
        DOUBLE_PROPERTY,
        selected ? selected.value : ''
      );

      clearHiddenProperty(
        SINGLE_PROPERTY
      );
    }
  }

  /***********************************************************************************/
  /* UPDATE VISIBLE FIELD                                                            */
  /***********************************************************************************/

  function updateNumberFields() {
    if (!isNumberCakePage()) return;

    const singleField =
      getSingleField();

    const doubleField =
      getDoubleField();

    if (!singleField || !doubleField) {
      return;
    }

    const size = getSelectedSize();

    if (!size) return;

    const sizeChanged =
      previousSize !== '' &&
      previousSize !== size;

    if (size === 'single') {
      showField(singleField);
      hideField(doubleField);

      /*
       * Customer changed from Double to Single.
       * Remove old Double number completely.
       */
      if (sizeChanged) {
        clearDoubleDigit();
      } else {
        clearHiddenProperty(
          DOUBLE_PROPERTY
        );
      }
    }

    if (size === 'double') {
      hideField(singleField);
      showField(doubleField);

      /*
       * Customer changed from Single to Double.
       * Remove old Single number completely.
       */
      if (sizeChanged) {
        clearSingleDigit();
      } else {
        clearHiddenProperty(
          SINGLE_PROPERTY
        );
      }
    }

    previousSize = size;

    syncActiveProperty();
  }

  /***********************************************************************************/
  /* VALIDATE ONLY ACTIVE NUMBER                                                     */
  /***********************************************************************************/

  function validateActiveNumber() {
    const size = getSelectedSize();

    const field =
      size === 'double'
        ? getDoubleField()
        : getSingleField();

    const selected =
      getSelectedNumber(field);

    if (!selected) {
      showError(
        field,
        size === 'double'
          ? 'Please select a double digit cake number.'
          : 'Please select a single digit cake number.'
      );

      const button = field?.querySelector(
        '.dropdown-button'
      );

      if (button) {
        button.focus();
      }

      return false;
    }

    removeError();

    return true;
  }

  /***********************************************************************************/
  /* FINAL CART PREPARATION                                                          */
  /***********************************************************************************/

  function prepareForCart() {
    const size = getSelectedSize();

    if (size === 'single') {
      showField(getSingleField());
      hideField(getDoubleField());

      clearDoubleDigit();

      const selected =
        getSelectedNumber(
          getSingleField()
        );

      activateHiddenProperty(
        SINGLE_PROPERTY,
        selected ? selected.value : ''
      );
    }

    if (size === 'double') {
      hideField(getSingleField());
      showField(getDoubleField());

      clearSingleDigit();

      const selected =
        getSelectedNumber(
          getDoubleField()
        );

      activateHiddenProperty(
        DOUBLE_PROPERTY,
        selected ? selected.value : ''
      );
    }
  }

  /***********************************************************************************/
  /* DELAYED UPDATE                                                                  */
  /***********************************************************************************/

  function scheduleUpdate() {
    clearTimeout(updateTimer);

    updateNumberFields();

    setTimeout(
      updateNumberFields,
      50
    );

    setTimeout(
      updateNumberFields,
      150
    );

    setTimeout(
      updateNumberFields,
      350
    );

    updateTimer = setTimeout(
      updateNumberFields,
      700
    );
  }

  /***********************************************************************************/
  /* EVENTS                                                                          */
  /***********************************************************************************/

  document.addEventListener(
    'change',
    function (event) {
      const target = event.target;

      /*
       * Number changed.
       */
      if (
        target.closest(
          SINGLE_FIELD_SELECTOR
        ) ||
        target.closest(
          DOUBLE_FIELD_SELECTOR
        )
      ) {
        removeError();

        setTimeout(
          syncActiveProperty,
          20
        );

        return;
      }

      /*
       * Shopify size/variant changed.
       */
      if (
        target.matches(
          'input[type="radio"]'
        ) ||
        target.matches(
          'input[name="id"]'
        ) ||
        target.matches(
          'select[name="id"]'
        )
      ) {
        removeError();
        scheduleUpdate();
      }
    }
  );

  document.addEventListener(
    'click',
    function (event) {
      const option = event.target.closest(
        'label, button, input[type="radio"]'
      );

      if (!option) return;

      if (
        option.closest(
          SINGLE_FIELD_SELECTOR
        ) ||
        option.closest(
          DOUBLE_FIELD_SELECTOR
        )
      ) {
        removeError();

        setTimeout(
          syncActiveProperty,
          30
        );

        return;
      }

      const text = String(
        option.textContent ||
        option.value ||
        ''
      )
        .trim()
        .toLowerCase();

      if (
        text.includes('single digit') ||
        text.includes('double digit')
      ) {
        removeError();

        setTimeout(
          scheduleUpdate,
          20
        );
      }
    }
  );

  /***********************************************************************************/
  /* ADD TO CART                                                                     */
  /***********************************************************************************/

  document.addEventListener(
    'click',
    function (event) {
      if (!isNumberCakePage()) return;

      const button = event.target.closest(
        'button[type="submit"], ' +
        'button[name="add"], ' +
        '.product-form__submit'
      );

      if (!button) return;

      prepareForCart();

      if (!validateActiveNumber()) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        return false;
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      if (
        !isNumberCakePage() ||
        !event.target.matches(
          'form[action*="/cart/add"]'
        )
      ) {
        return;
      }

      prepareForCart();

      if (!validateActiveNumber()) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        return false;
      }
    },
    true
  );

  /***********************************************************************************/
  /* WAIT FOR GLOBO                                                                  */
  /***********************************************************************************/

  const observer =
    new MutationObserver(function () {
      if (
        getSingleField() &&
        getDoubleField()
      ) {
        scheduleUpdate();
      }
    });

  function initialize() {
    if (!isNumberCakePage()) return;

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

    scheduleUpdate();

    setTimeout(
      scheduleUpdate,
      500
    );

    setTimeout(
      scheduleUpdate,
      1000
    );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

  window.addEventListener(
    'load',
    scheduleUpdate
  );

  window.addEventListener(
    'pageshow',
    function () {
      previousSize = '';
      scheduleUpdate();
    }
  );
})();
